export default class BtnScrollTop {
  constructor() {
    this.CL_SHOW = 'isShow';

    this.target = document.querySelector('.gl_common_btn_scroll_top');

    window.addEventListener('scroll',this.onScroll.bind(this));
    this.onScroll();
  }

  onScroll() {
    const st = window.scrollY;

    if(st > 0) this.target.classList.add(this.CL_SHOW);
    else this.target.classList.remove(this.CL_SHOW);
  }
}
